import { render, staticRenderFns } from "./ClientBlock.vue?vue&type=template&id=403bb0e0&scoped=true"
import script from "./ClientBlock.vue?vue&type=script&lang=js"
export * from "./ClientBlock.vue?vue&type=script&lang=js"
import style0 from "./ClientBlock.vue?vue&type=style&index=0&id=403bb0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403bb0e0",
  null
  
)

export default component.exports